import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.e5t_1 = delegate;
        this.f5t_1 = call;
      }
      *e5b(frame, $completion) {
        yield* this.e5t_1.e5b(frame, $completion);
        return Unit_instance;
      }
      *g4k($completion) {
        yield* this.e5t_1.g4k($completion);
        return Unit_instance;
      }
      a5b(_set____db54di) {
        this.e5t_1.a5b(_set____db54di);
      }
      b5b() {
        return this.e5t_1.b5b();
      }
      c5b() {
        return this.e5t_1.c5b();
      }
      d5b() {
        return this.e5t_1.d5b();
      }
      bw() {
        return this.e5t_1.bw();
      }
      z5a(negotiatedExtensions) {
        this.e5t_1.z5a(negotiatedExtensions);
      }
      y5a() {
        return this.e5t_1.y5a();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.g5t_1 = session;
        this.h5t_1 = call;
      }
      *e5b(frame, $completion) {
        yield* this.g5t_1.e5b(frame, $completion);
        return Unit_instance;
      }
      *g4k($completion) {
        yield* this.g5t_1.g4k($completion);
        return Unit_instance;
      }
      a5b(_set____db54di) {
        this.g5t_1.a5b(_set____db54di);
      }
      b5b() {
        return this.g5t_1.b5b();
      }
      c5b() {
        return this.g5t_1.c5b();
      }
      d5b() {
        return this.g5t_1.d5b();
      }
      bw() {
        return this.g5t_1.bw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
